module.exports = __webpack_public_path__ + "dataanalysestatic/img/zhiliao.1c1090c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhiliao.png
// module id = j5aA
// module chunks = 37